import React from 'react';

import { ProductHighlights } from '.';
import type { ProductHighlightsEntry } from 'schema';
import { SmartImage } from 'components/global/SmartImage';

export const ContentfulProductHighlights = ({
  glyphs,

  ...props
}: ProductHighlightsEntry) => {
  return (
    <ProductHighlights
      glyphs={glyphs.map(({ header, media, textColor }) => ({
        name: header,
        glyph: <SmartImage {...media} />,
        textColor,
      }))}
      {...props}
    />
  );
};
